export class ConceptJoinInfo {
  winner: string;
  losers: Array<string>;
}

export class ConceptJoinResult {
  status = 'ok';
  message: string;
}
